import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const PayBillAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHavePayBillsAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            payBill: {
              isHaveAddAccess: true,
              isHaveExportAccess: true,
              isHaveEditAccess: true,
              isHaveDeleteAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            payBill: {
              isHaveAddAccess: false,
              isHaveExportAccess: false,
              isHaveEditAccess: false,
              isHaveDeleteAccess: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHavePayBillsAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      payBill: { ...j.payBill, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHavePayBillsAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.payBill &&
              featuresAccess.payBill.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.payBill &&
              featuresAccess.payBill.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.payBill &&
              featuresAccess.payBill.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.payBill &&
              featuresAccess.payBill.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default PayBillAccess;
